import React from "react";

export type Tab = {
  code: string;
  name: string;
};

interface TabsProps {
  tabs: Tab[];
  selected: string;
  onSelect: (code: string) => void;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, selected, onSelect, className = "" }) => {
  return (
    <div className={`text-center text-gray-500 ${className}`}>
      <ul className="-mb-px flex flex-wrap border-b-2 border-gray-200">
        {tabs.map((tab) => (
          <li className="me-8" key={tab.code}>
            <a
              href="#"
              className={
                "inline-block rounded-t-lg py-1 " +
                (selected === tab.code
                  ? "active border-b-2 border-primaryPurple-100 font-medium text-black"
                  : "border-transparent font-normal hover:text-gray-600")
              }
              onClick={(e) => {
                e.preventDefault();
                onSelect(tab.code);
              }}
            >
              {tab.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
